import React, {useCallback, useEffect, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Container, DialogActions,
	DialogContentText,
	Tooltip,
	Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {useForm, FormProvider} from "react-hook-form";
import Button from "@mui/material/Button";
import SimpleDialog from "../../../widgets/dialogs/SimpleDialog";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import {bigNoteRegisterRequired, emailRegister, valueRegister} from "../../../../utils/RegisterUtils";
import CustomText from "../../../widgets/inputs/CustomText";
import clsx from "clsx";
import Background from "../../../../assets/Ocean-bg.png";
import HideAppBar from "../../../widgets/header/HideAppBar";


const MailAnonima = () => {
	const classes = BaseStyle();
	const methods = useForm({
		mode: "onChange"
	});
	const [info, setInfo] = useState(false);
	
	const onSubmit = useCallback((data) => {
		console.log(data);
	}, []);
	
	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Invia mail no-reply"} back={true} backPosition={"/gestione/tickets"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<FormProvider {...methods}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Card className={clsx(classes.roundBorder, classes.transparent80)}
								      style={{height: "100%", display: "flex", flexDirection: "column"}}>
									<CardHeader
										title={<Typography variant={"h6"}><b>Dettaglio mail</b></Typography>}
										subheader={"Indica i vari parametri della mail per poterla inviare a chi di dovere."}
									/>
									<CardContent style={{flexGrow: 1}}>
										<Grid container spacing={3}>
											<Grid item xs={12}>
												<CustomText
													inputRef={methods.register(emailRegister)}
													name={"email"}
													label={"Email del destinatario"}
													autoFocus={true}
													error={methods.errors["email"]}
												/>
											</Grid>
											<Grid item xs={12}>
												<CustomText
													inputRef={methods.register(valueRegister)}
													name={"oggetto"}
													label={"Oggetto"}
													autoFocus={true}
													error={methods.errors["oggetto"]}
												/>
											</Grid>
											<Grid item xs={12}>
												<CustomMultiText
													inputRef={methods.register(bigNoteRegisterRequired)}
													name={"messaggio"}
													label={"Messaggio della mail"}
													autoFocus={false}
													error={methods.errors["messaggio"]}
													rows={10}
												/>
											</Grid>
										</Grid>
									</CardContent>
									<CardActions className={classes.flexRight}>
										<Tooltip title={"Alcune informazioni sulla gestione della destinazione e sul ticket in generale"}>
											<Button variant={"text"} disableElevation size={"small"}
											        className={classes.roundButton} onClick={() => setInfo(!info)}>
												<b>info</b>
											</Button>
										</Tooltip>
										<Tooltip title={"Conferma i dati inseriti sopra ed invia la mail"}>
											<Button variant={"contained"} size={"small"} disableElevation color="primary"
											        className={classes.roundButton} onClick={methods.handleSubmit(onSubmit)}>
												<b>Conferma ed invia</b>
											</Button>
										</Tooltip>
									</CardActions>
								</Card>
							</Grid>
							
							{
								info && <SimpleDialog open={info} maxWidth={"md"} title={"Informazioni sulla mail \"anonima\""}
								                      handleClose={() => setInfo(false)}
								                      content={<DialogContentText>
									                      <b>Cosa vuol dire mail no-reply o anonima?</b><br/>
									                      La mail verrà inviata dall'indirizzo postale dell'ASL Città di Torino
									                      "no-reply@aslcittaditorino.it" con alias "no-reply-gruppo-ocean" in modo tale da
									                      non permettere all'utente base di riuscire a rispondere. L'utente visualizzerà
									                      nella mail il bottone che lo rimanderà al form contattaci in caso ne abbia
									                      bisogno, così che apra un ticket.<br/><br/>
									
									                      <b>Quando usare una mail anonima?</b><br/>
									                      L'uso di questa mail è pensato per tutti quei casi in cui si vogliono inviare
									                      email a dei pazienti in forma anonima senza che il paziente possa
									                      rispondere. Se l'obiettivo d'uso intende dare la possibilità al paziente finale
									                      di poter rispondere allora conviene utilizzare i ticket, creandone uno dal primo
									                      livello Callcenter<br/><br/>
								                      </DialogContentText>} actions={
									<DialogActions>
										<Button onClick={() => setInfo(false)} size="small" disableElevation
										        variant={"contained"}
										        className={classes.roundButton} color={"primary"} autoFocus>
											<b>Ok, chiudi</b>
										</Button>
									</DialogActions>}/>
							}
						
						</Grid>
					</FormProvider>
				</Container>
			</main>
		</React.Fragment>
	);
};

export default React.memo(MailAnonima);
